export const common = {
  contact: "contacts/site/",
  subscribe: "contacts/email/",
};
